exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "loans-detail-statement-income .loans-detail-statement-income{margin-top:25px;padding-right:70px}loans-detail-statement-income .loans-detail-statement-income.mobile{padding-right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/loansDetail/loansDetailStatementIncome/loansDetailStatementIncome.scss
// module id = 1881
// module chunks = 0